import React from 'react';
import { Archive } from 'lucide-react';
import { resolveWaybackHref } from '../utils/waybackUrl';

interface Props {
  url?: string | null;
  waybackUrl?: string | null;
  name: string;
  darkMode: boolean;
  /** Buton stili (Karşılaştır satırı) */
  compact?: boolean;
  /** Kategori / Ziyaret Et ile aynı pill satırı */
  pill?: boolean;
}

const WaybackLink: React.FC<Props> = ({ url, waybackUrl, name, darkMode, compact, pill }) => {
  const href = resolveWaybackHref(waybackUrl, url);
  if (!href) return null;

  if (pill) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        title={`Internet Archive — ${name}`}
        className={`inline-flex items-center gap-1 px-2 py-1 sm:px-3 rounded-full text-xs sm:text-sm transition-colors ${
          darkMode
            ? 'bg-amber-900/40 text-amber-300 hover:bg-amber-900/60'
            : 'bg-amber-50 text-amber-800 hover:bg-amber-100'
        }`}
      >
        <Archive size={16} className="shrink-0" />
        Web Arşivi
      </a>
    );
  }

  if (compact) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        title={`Internet Archive — ${name}`}
        className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm border transition-colors ${
          darkMode
            ? 'bg-amber-900/30 border-amber-800/60 text-amber-300 hover:bg-amber-900/50'
            : 'bg-amber-50 border-amber-200 text-amber-800 hover:bg-amber-100'
        }`}
      >
        <Archive size={16} className="shrink-0" />
        Web Arşivi
      </a>
    );
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center gap-1 text-sm ${darkMode ? 'text-amber-400 hover:text-amber-300' : 'text-amber-700 hover:text-amber-900'}`}
    >
      <Archive size={16} />
      Internet Archive — {name}
    </a>
  );
};

export default WaybackLink;
